import ImcInfo from './ImcInfo';

export default ImcInfo;
